import {NgModule} from '@angular/core';
import {TreeCommonComponent} from './components/common/tree-common.component';
import {GlobalModule} from '@app/core/global.module';
import {OverlayModule} from '@angular/cdk/overlay';
import {TreeDirective} from './tree.directive';
import {TreeAddOptionsComponent} from './components/add-options/tree-add-options.component';
import {HighlightModule} from '../highlight/highlight.module';
import {InputSearchModule} from '@components/input-search/input-search.module';
import {ButtonModule} from '@components/button/modules/button.module';
import {HoverModule} from '../hover/hover.module';

@NgModule({
    declarations: [
        TreeDirective,
        TreeCommonComponent,
        TreeAddOptionsComponent],
    exports: [
        TreeDirective,
        TreeCommonComponent,
        TreeAddOptionsComponent
    ],
    imports: [
        GlobalModule,
        OverlayModule,
        HighlightModule,
        InputSearchModule,
        ButtonModule,
        HoverModule
    ]
})
export class TreeModule {
}
